<template>
  <div class="tab-pane" id="dtab1" role="tabpanel">
    <div class="mb-3 pr-4">
      <h3>{{$t('settings')}}</h3>

    <div class="select2-container font12 text-dark mb-4" v-if="doc.reporttype == '0'">
      <span class="pr-4"> {{$t('date')}} </span> <i class="fa fa-calendar pr-2" aria-hidden="true"></i>

      <select v-model="dailyReportDate" class="select-2 form-control" @change="getPhotosOfDailyReport(dailyReportDate)" id="select-2" style="display: inline">
          <option v-for="photo in photoDates" :value="photo.date">
            {{setDateformat(photo.date)}}
          </option>
        </select>
     </div>

      <div class="switch mb-3 mt-2" style="border-bottom: 1px solid darkgray;">
        <label class="w-100 font-bold" > Bericht sperren<br /><small>(Bei Änderungen wird eine neue Revision angelegt)</small>
          <input type="checkbox"  v-model="doc.locked" :disabled="isLocked">
          <span class="lever float-right mr-0"></span>
        </label>
      </div>

      <div class="switch mb-3" style="border-bottom: 1px solid darkgray;">
        <label class="w-100  mb-2 font-bold"> Bericht mit Planzuordnung erstellen
          <input type="checkbox"   v-model="doc.incplan">
          <span class="lever float-right mr-0"></span>
        </label>
        <label class="w-100  pl-4 mb-2 font-bold"> verkleinerte Punkte auf Plan verwenden (Beta)<br /><small>(dieser Vorgang kann mehrere Minuten dauern)</small>
          <input type="checkbox" value="1"  v-model="doc.reportparams.smallplandots">
          <span class="lever float-right mr-0"></span>
        </label>
      </div>


      <div class="switch mb-3 ">
        <label class="w-100 font-bold">Anzahl Fotos pro Seite</label>

        <label class="w-100 pl-4 mb-2 font-bold"> 2 Fotos pro Seite (Standard)<br /><small>(inkl. Fotonummer, Erstellungsdatum, Originalname, Schlagworte, Beschreibung und ggfs. Planzuordnung)</small>
          <input type="radio" :value="0"  v-model="doc.reportparams.singlephotopage">
          <span class="lever float-right mr-0"></span>
        </label>

        <label class="w-100 pl-4 mb-0 font-bold"> 1 Foto pro Seite<br /><small>(inkl. Fotonummer, Erstellungsdatum, Originalname, Schlagworte, Beschreibung und ggfs. Planzuordnung)</small>
          <input type="radio" :value="1"  v-model="doc.reportparams.singlephotopage">
          <span class="lever float-right mr-0"></span>
        </label>

        <label class="w-100 pl-5 mb-2 font-bold"> Planausschnitt einblenden<br /><small>(Unten Rechts auf der Seite wird ein kleiner Planausschnitt wenn vorhanden eingeblendet.)</small>
          <input type="checkbox" :value="1"  v-model="doc.reportparams.showplancut">
          <span class="lever float-right mr-0"></span>
        </label>

        <label class="w-100 pl-4 mb-2 font-bold d-none"> 4 Fotos pro Seite<br /><small>(inkl. Fotonummer, Erstellungsdatum)</small>
          <input type="radio" value="4"  v-model="doc.reportparams.singlephotopage">
          <span class="lever float-right mr-0"></span>
        </label>


      </div>



      <div class="switch mb-3 w-100">

      </div>
    </div>
  </div>
</template>
<script>
import  axios from '../../../utils/axiosinstance'
import {formatDate, formatDateHash} from '../../common'
import moment from 'moment'
export default {
  data () {
    return {
       photoDates: [],
       selected_date: '',
       isLocked: false
    }
  },
  created () {
    if (this.doc.reporttype == '0'){
      this.getDailyReportPhotosDates();
    }
  },
  computed: {
    doc () {
      if (this.$route.name === 'photoDocumentEdit'){
        if(this.$store.state.photoDocumentation.selectedDocument.reportparams == undefined) {
          this.$store.state.photoDocumentation.selectedDocument.reportparams.singlephotopage = 0
          this.$store.state.photoDocumentation.selectedDocument.reportparams.showplancut = 0
        }
        if(this.$store.state.photoDocumentation.selectedDocument.reportparams == undefined) {
          this.$store.state.photoDocumentation.selectedDocument.reportparams.showplancut = 0
        }
        return  this.$store.state.photoDocumentation.selectedDocument
      }else {
        return this.$store.state.photoDocumentation.newDocumentDetails
      }
    },
    dailyReportDate: {
      get(){
        return this.$store.state.photoDocumentation.dailyReportDate
      },
      set(val){
        this.$store.commit('setDailyReportDate',val)
      }
    }
  },

  mounted () {
    this.getPhotosOfReport();
    if (this.$route.name === 'photoDocumentEdit'){
      this.isLocked = this.doc.locked
    }
  },



  methods: {
    async getPhotosOfReport(){
      if (this.$route.name === "photoDocumentEdit" && this.doc.reporttype == '0'){
        await  this.getPhotosOfDailyReport(this.doc.reportdate);
        this.dailyReportDate =  this.setDateformatHash(this.doc.reportdate);
      }
    },

    setDateformat: (date) => formatDate(date),
    setDateformatHash: (date) => formatDateHash(date),

    getDatesParams(){
     let id = this.$route.params.id
     return [id,
        {
          "_explicitType": "com\\projectdocu\\PredicateOperatorAndVO",
          "operands":[{
            "_explicitType": "com\\projectdocu\\PredicateOperandEQVO",
            "fieldvalue" : 1,
            "fieldname" : "dailydocu"
          }],
        },
        [{
          _explicitType: "com\\projectdocu\\OrderSettingVO",
          fieldname: "date-day",
          order: "DESC"
        }]
      ]
    },

    dailyProjectPhotosParams(report_date){
     let id = this.$route.params.id
      return [id, null, 0 ,
        {
          "_explicitType": "com\\projectdocu\\PredicateOperatorAndVO",
          "operands":[{
            _explicitType: "com\\projectdocu\\PredicateOperandEQVO",
            fieldvalue: 1,
            fieldname: "dailydocu"
          }, {
              _explicitType: "com\\projectdocu\\PredicateOperandEQVO",
              fieldname: 'photodate-day',
              fieldvalue : report_date,
            }
          ],
        },
        [{
          _explicitType: "com\\projectdocu\\OrderSettingVO",
          fieldname: "photodate",
          order: "DESC"
        }]
      ]
    },

    async getDailyReportPhotosDates(){
     await axios.post(`${process.env.VUE_APP_BASE_AMF_URL}&token=${localStorage.sessiontoken}`,
       {
         "methodName": "getPhotoCountsByDate",
         "serviceName": "ProjectdocuService",
         "parameters": this.getDatesParams()
       },
       {
         headers: {
           apitoken: localStorage.apikey,
           deviceid: localStorage.deviceid,
           accept: 'application/json'
         }
       }).then(res=> {
            this.photoDates = res.data.photos;
            if (this.$route.name === 'photoDocumentCreate' && this.doc.reporttype == '0'){
              this.getPhotosOfDailyReport(res.data.photos[0].date);
              this.dailyReportDate = res.data.photos[0].date
            }
     }).catch(error =>{
       console.log(error)
     });
    },


    //for a new project
    async getPhotosOfDailyReport(report_date){
      this.doc.reportdate = report_date
      this.$store.commit('toggleLoading',true);
      let _this = this
      await axios.post(`${process.env.VUE_APP_BASE_AMF_URL}&token=${localStorage.sessiontoken}`,
        {
          "methodName": "getPhotosOfProject",
          "serviceName": "ProjectdocuService",
          "parameters": _this.dailyProjectPhotosParams(report_date)
        },
        {
          headers: {
            apitoken: localStorage.apikey,
            deviceid: localStorage.deviceid,
            accept: 'application/json'
          }
        }).then(res=> {
          console.log('Result', res.data)
          // _this.getFilesDocsModule(res.data.photos)
          const photosArray = res.data.photos;

          // Debug: Überprüfen, ob das Array korrekt ist
          if (!photosArray || !Array.isArray(photosArray)) {
            console.error("Photos array is missing or invalid:", photosArray);
            return;
          }

          // Übergabe von Daten an die Funktion
          this.getFilesDocsModule(photosArray);


      }).catch(error =>{
        console.log(error)
      });
    },

    //Get Photo Files for new daily report
    async getFilesDocsModule (photos) {
      let _this = this
      _this.$store.commit('setDailyReportPhotos',[]);

      if(photos.length >= 1){
        await photos.forEach(photo => {
          fetch(`${process.env.VUE_APP_GET_METHOD_URL}img&projectid=${photo.projectid}&id=${photo.pdphotoid}&token=${localStorage.sessiontoken}`,
            {
              headers: {
                apitoken: localStorage.apikey,
                deviceid: localStorage.deviceid,
              }
            }).then(response => response.blob())
            .then(response => {
              let reader = new FileReader()
              reader.readAsDataURL(response)
              reader.onload = function () {
                photo.src = reader.result;
                photo.pdphototext = photo.description;
                _this.$store.commit('setDailyReportPhotos',photo);
              }
              _this.$store.commit('toggleLoading',false);
            }).catch(error =>{
            console.log(error);
          })
        })
      }
    },

  }
}
</script>
<style scoped>
.text-dark.font12{
  font-size: 1rem !important;
}
.fa-calendar{
  font-size: 1.2rem;
}
select#select-2{
 width: 32%;
}
</style>
<style>
.docuvtabs .tab-content .switch label input[type=checkbox]:disabled + .lever {
  background-color: #717a9b !important;
  border-color: #494242;
}
</style>



// WEBPACK FOOTER //
// src/components/photoDocumentation/components/TextPageTab.vue